import { CONTENT_DETAILS } from 'components/ContentReporting/ContentLegalReporting/content-legal-reporting-config';
import { CONTENT_TYPES } from 'components/ContentReporting/content-types';
import { CONTENT_TYPE } from 'containers/ContentReporting/ContentLegalReporting/utils/types/claim';

// This is introduced due to different number of URIs per claim type
// For OPTIONS_CLAIM_TYPE.OTHER there's a 10 URI limit
export const MAXIMUM_NUMBER_URIS_NON_IP = 10;
export const MAXIMUM_NUMBER_ARTIST_IMAGE_URIS = 5;
// For non OPTIONS_CLAIM_TYPE.OTHER claim type, there's a 200 URI limit
export const MAXIMUM_NUMBER_URIS = 200;

export const URI_FIELDS: {
  [contentType: string]: { acceptedUriTypes: CONTENT_TYPES[]; label: string; maximumNumberOfURI?: number };
} = {
  [CONTENT_TYPE.MUSIC]: {
    acceptedUriTypes: [CONTENT_TYPES.TRACK, CONTENT_TYPES.ALBUM],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.PODCAST]: {
    acceptedUriTypes: [CONTENT_TYPES.SHOW, CONTENT_TYPES.EPISODE],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.AUDIOBOOK]: {
    acceptedUriTypes: [CONTENT_TYPES.SHOW, CONTENT_TYPES.EPISODE],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.ARTWORK]: {
    acceptedUriTypes: [CONTENT_TYPES.TRACK, CONTENT_TYPES.ALBUM, CONTENT_TYPES.SHOW, CONTENT_TYPES.EPISODE],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.USER_IMAGE]: {
    acceptedUriTypes: [CONTENT_TYPES.USER],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.ARTIST_BIO_TEXT]: {
    acceptedUriTypes: [CONTENT_TYPES.ARTIST],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_ONE_URI,
    maximumNumberOfURI: 1,
  },
  [CONTENT_TYPE.ARTIST_PICK_TEXT]: {
    acceptedUriTypes: [CONTENT_TYPES.ARTIST],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_ONE_URI,
    maximumNumberOfURI: 1,
  },
  [CONTENT_TYPE.ARTIST_PROFILE_IMAGE]: {
    acceptedUriTypes: [CONTENT_TYPES.ARTIST],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_ONE_URI,
    maximumNumberOfURI: MAXIMUM_NUMBER_ARTIST_IMAGE_URIS,
  },
  [CONTENT_TYPE.ARTIST_BANNER_IMAGE]: {
    acceptedUriTypes: [CONTENT_TYPES.ARTIST],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_ONE_URI,
    maximumNumberOfURI: MAXIMUM_NUMBER_ARTIST_IMAGE_URIS,
  },
  [CONTENT_TYPE.ARTIST_GALLERY_IMAGE]: {
    acceptedUriTypes: [CONTENT_TYPES.ARTIST],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_ONE_URI,
    maximumNumberOfURI: MAXIMUM_NUMBER_ARTIST_IMAGE_URIS,
  },
  [CONTENT_TYPE.ARTIST_MERCHANDISE]: {
    acceptedUriTypes: [CONTENT_TYPES.ARTIST],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_ONE_URI,
    maximumNumberOfURI: 1,
  },
  [CONTENT_TYPE.PLAYLIST_DESCRIPTION]: {
    acceptedUriTypes: [CONTENT_TYPES.PLAYLIST, CONTENT_TYPES.PLAYLIST_OLD],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.PLAYLIST_IMAGE]: {
    acceptedUriTypes: [CONTENT_TYPES.PLAYLIST, CONTENT_TYPES.PLAYLIST_OLD],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.PLAYLIST_TITLE]: {
    acceptedUriTypes: [CONTENT_TYPES.PLAYLIST, CONTENT_TYPES.PLAYLIST_OLD],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.NOW_PLAYING]: {
    acceptedUriTypes: [CONTENT_TYPES.TRACK],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.ARTIST_VIDEO_VIDEO]: {
    acceptedUriTypes: [CONTENT_TYPES.ARTIST_VIDEO],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.ARTIST_VIDEO_TITLE]: {
    acceptedUriTypes: [CONTENT_TYPES.ARTIST_VIDEO],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.ARTIST_VIDEO_AUDIO]: {
    acceptedUriTypes: [CONTENT_TYPES.ARTIST_VIDEO],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.POLL_QUESTION_TEXT]: {
    acceptedUriTypes: [CONTENT_TYPES.POLL],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.COMMENT_TEXT]: {
    acceptedUriTypes: [CONTENT_TYPES.COMMENT],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.POLL_OPTIONS_TEXT]: {
    acceptedUriTypes: [CONTENT_TYPES.POLL],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.MERCH_TITLE]: {
    acceptedUriTypes: [CONTENT_TYPES.MERCH],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.MERCH_DESCRIPTION]: {
    acceptedUriTypes: [CONTENT_TYPES.MERCH],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.MERCH_IMAGE_GALLERY]: {
    acceptedUriTypes: [CONTENT_TYPES.MERCH],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
    maximumNumberOfURI: 1,
  },
  [CONTENT_TYPE.MUSIC_VIDEO]: {
    acceptedUriTypes: [CONTENT_TYPES.TRACK],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.EPISODE_VIDEO_PREVIEW_AUDIO]: {
    acceptedUriTypes: [CONTENT_TYPES.EXPRESSION],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.EPISODE_VIDEO_PREVIEW_VIDEO]: {
    acceptedUriTypes: [CONTENT_TYPES.EXPRESSION],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.EPISODE_VIDEO_PREVIEW_TITLE]: {
    acceptedUriTypes: [CONTENT_TYPES.EXPRESSION],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.CHAT_MESSAGE_TEXT]: {
    acceptedUriTypes: [CONTENT_TYPES.CHAT_MESSAGE],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.SUPPLEMENTARY_PDF]: {
    acceptedUriTypes: [CONTENT_TYPES.SUPPLEMENTARY_MATERIAL],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  [CONTENT_TYPE.OTHER]: {
    acceptedUriTypes: [
      CONTENT_TYPES.TRACK,
      CONTENT_TYPES.ALBUM,
      CONTENT_TYPES.SHOW,
      CONTENT_TYPES.EPISODE,
      CONTENT_TYPES.USER,
      CONTENT_TYPES.ARTIST,
      CONTENT_TYPES.PLAYLIST,
      CONTENT_TYPES.PLAYLIST_OLD,
    ],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
  UNKNOWN: {
    acceptedUriTypes: [
      CONTENT_TYPES.TRACK,
      CONTENT_TYPES.ALBUM,
      CONTENT_TYPES.SHOW,
      CONTENT_TYPES.EPISODE,
      CONTENT_TYPES.USER,
      CONTENT_TYPES.ARTIST,
      CONTENT_TYPES.PLAYLIST,
      CONTENT_TYPES.PLAYLIST_OLD,
    ],
    label: CONTENT_DETAILS.labels.REPORTED_CONTENT_URIS,
  },
};
